// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__4ENXF","row":"Header_row__zTtzd"};